import React, { PropsWithChildren } from "react";

import {
  SvgIcon as MuiSvgIcon,
  SvgIconProps,
  styled,
  useTheme,
} from "@mui/material";

export type SVGIconColor =
  | "grey"
  | "pink"
  | "white"
  | "green"
  | "light-grey"
  | "blue"
  | "none";

type PropTypes = Omit<SvgIconProps, "color"> &
  PropsWithChildren & {
    color?: SVGIconColor;
    width?: number;
    height?: number;
  };

export const SvgIcon: React.FC<PropTypes> = ({
  children,
  color = "DEFAULT",
  width,
  height,
  ...rest
}) => {
  const theme = useTheme();
  type ColorKeys = NonNullable<PropTypes["color"]>;
  const colors: Record<ColorKeys, string> = {
    grey: theme.palette.grey1.main,
    "light-grey": theme.palette.grey1[200],
    pink: theme.palette.pink.main,
    white: theme.palette.white.main,
    green: theme.palette.green.main,
    none: "",
    blue: theme.palette.blue.main,
  };

  const StyledIcon = styled(MuiSvgIcon)<{ width?: number; height?: number }>(
    ({ width, height }) => ({
      "& path": {
        fill: colors[color as ColorKeys],
      },
      width: width ? `${width}px` : undefined,
      height: height ? `${height}px` : undefined,
    }),
  );

  return (
    <StyledIcon width={width} height={height} {...rest}>
      {children}
    </StyledIcon>
  );
};
